<kendo-formfield showHint="initial" showErrors="initial" [formGroup]="formGroup">
  <kendo-label [text]="data.key | i18nMetadata"></kendo-label>
  <input kendoTextBox [formControlName]="data.key + data.valueType"  />
  <kendo-formhint>{{ 'circ_template_formhint_text' | i18n }}</kendo-formhint>
  <kendo-formerror>
    <ng-container *ngIf="formGroup.controls[data.key + data.valueType].errors as err">
      <div *ngIf="err.required">{{ 'circ_metadata_formerror_required' | i18n }}</div>
    </ng-container>
  </kendo-formerror>
</kendo-formfield>
